(function() {
	'use strict';

	var unserializeUrl = avm.require('avast.url.unserialize'),
		decorator = avm.require('avast.web.linkDecorator'),
		params;

		params = Object.keys ? Object.keys(unserializeUrl()) : [];

	function decorate(){
		return decorator('.js-research', params);
	}

	// On page load
	return decorate();
})();
